import { brandsSlice, callTypes } from "./brandsSlice";
import Axios from 'axios'
import { getCookie } from "../products/productsActions";
import * as skinCareActions from '../products/productsActions'
import * as bodyCareActions from '../bodyCareproducts/productsActions'
import * as hairCareActions from '../hairCareproducts/productsActions'

const { actions } = brandsSlice;

// brands

export const fetchBrands = (queryParams, page) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  Axios({
    method: 'get',
    url: page ? process.env.REACT_APP_BACKEND_URL + `/api/admin/v2/brand/?page=${page}&page_size=${10}` : process.env.REACT_APP_BACKEND_URL + `/api/admin/v2/brand/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      let brands = response.data.results
      let totalCount = response.data.count
      dispatch(actions.brandsFetched({ brands, totalCount }));
      return brands
    })
    .catch(error => {
      console.log(error)
    });
};


export const AddBrand = (queryParams, page, brandType) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  let data = new FormData()
  data.append("name", queryParams)
  data.append("brand_type", brandType)
  Axios({
    method: 'POST',
    url: process.env.REACT_APP_BACKEND_URL + '/api/admin/brand/',
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
    data,
  })
    .then(response => {
      dispatch(fetchBrands(false, page))
    })
    .catch(error => {
      console.log(error)
    });
};

export const DeleteBrand = (queryParams, page) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  // let data = new FormData()
  // data.append("name", queryParams)
  Axios({
    method: 'DELETE',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/brand/${queryParams}/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      dispatch(fetchBrands(false, page))
    })
    .catch(error => {
      console.log(error)
    });
};

export const UpdateBrand = (id, name, page, brandType) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  let data = new FormData()
  data.append("name", name)
  data.append("brand_type", brandType)
  Axios({
    method: 'PUT',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/brand/${id}/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
    data,
  })
    .then(response => {
      dispatch(fetchBrands(false, page))
    })
    .catch(error => {
      console.log(error)
    });
};

export const fetchBrandsTypes = () => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  Axios({
    method: 'get',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/brand-type/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      let brandsTypes = response.data
      dispatch(actions.brandsTypesFetched({ brandsTypes }));
      return brandsTypes
    })
    .catch(error => {
      console.log(error)
    });
};

// secondary images

export const fetchSecondaryImages = (page) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  Axios({
    method: 'get',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/v2/secondary-image/?page=${page}&page_size=${8}`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      let secondaryImages = response.data.results
      let totalCount = response.data.count
      dispatch(actions.secondaryImagesFetched({ secondaryImages, totalCount }));
      return secondaryImages
    })
    .catch(error => {
      console.log(error)
    });
};


export const AddSecondaryImages = (queryParams, image, name) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  let data = new FormData()
  data.append("product", Number(queryParams))
  data.append("image", image)
  Axios({
    method: 'POST',
    url: process.env.REACT_APP_BACKEND_URL + '/api/admin/secondary-image/',
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
    data,
  })
    .then(response => {
      console.log(response)
      // if (name === "Body Care Products") {
      //   dispatch(bodyCareActions.fetchProducts(true))
      // }
      // if (name === "Skin Care Products") {
      //   dispatch(skinCareActions.fetchProducts(true))
      // }
      // if (name === "Hair Care Products") {
      //   dispatch(hairCareActions.fetchProducts(true))
      // }
    })
    .catch(error => {
      console.log(error)
    });
};

export const DeleteSecondaryImage = (queryParams, name, page, previousData) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  // let data = new FormData()
  // data.append("name", queryParams)
  Axios({
    method: 'DELETE',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/secondary-image/${queryParams}/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      let pagee = previousData.length === 1 ? page - 1 : page
      dispatch(fetchSecondaryImages(pagee))
    })
    .catch(error => {
      console.log(error)
    });
};

export const UpdateSecondaryImage = (id, product, image, name) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  let data = new FormData()
  data.append('product', product)
  if (image) {
    data.append('image', image)
  }
  Axios({
    method: 'PUT',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/secondary-image/${id}/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
    data,
  })
    .then(response => {
      // dispatch(fetchSecondaryImages())
      // if (name === "Body Care Products") {
      //   dispatch(bodyCareActions.fetchProducts(true))
      // }
      // if (name === "Skin Care Products") {
      //   dispatch(skinCareActions.fetchProducts(true))
      // }
      // if (name === "Hair Care Products") {
      //   dispatch(hairCareActions.fetchProducts(true))
      // }
    })
    .catch(error => {
      console.log(error)
    });
};


// skin concerns

export const fetchskinConcerns = (queryParams, page) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  Axios({
    method: 'get',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/v2/${queryParams ? queryParams : "skin-concern"}/?page=${page}&page_size=${10}`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      let skinConcerns = response.data.results.sort((a, b) => b.id - a.id)
      let totalCount = response.data.count
      dispatch(actions.skinConcernsFetched({ skinConcerns, totalCount }));
      return skinConcerns
    })
    .catch(error => {
      console.log(error)
    });
};

export const AddSkinConcern = (concern_name, user_profile, queryParams, page) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  let data = new FormData()
  data.append("concern_name", concern_name)
  data.append("user_profile", user_profile)
  Axios({
    method: 'POST',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/${queryParams ? queryParams : "skin-concern"}/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
    data,
  })
    .then(response => {
      // dispatch(fetchskinConcerns(queryParams, page))
    })
    .catch(error => {
      console.log(error)
    });
};

export const DeleteSkinConcern = (id, queryParams, page) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  // let data = new FormData()
  // data.append("name", id)
  Axios({
    method: 'DELETE',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/${queryParams ? queryParams : "skin-concern"}/${id}/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      // dispatch(fetchskinConcerns(queryParams, page))
    })
    .catch(error => {
      console.log(error)
    });
};


export const AddHairConcern = (concern_name, user_profile, queryParams, page) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  let data = new FormData()
  data.append("concern_name", concern_name)
  data.append("user_profile", user_profile)
  Axios({
    method: 'POST',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/${queryParams ? queryParams : "hair-concern"}/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
    data,
  })
    .then(response => {
      // dispatch(fetchskinConcerns(queryParams, page))
    })
    .catch(error => {
      console.log(error)
    });
};

export const DeleteHairConcern = (id, queryParams, page) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  // let data = new FormData()
  // data.append("name", id)
  Axios({
    method: 'DELETE',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/${queryParams ? queryParams : "hair-concern"}/${id}/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      // dispatch(fetchskinConcerns(queryParams, page))
    })
    .catch(error => {
      console.log(error)
    });
};

export const AddBrandPref = (concern_name, user_profile, queryParams, page) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  let data = new FormData()
  data.append("brand_type", concern_name)
  data.append("user_profile", user_profile)
  Axios({
    method: 'POST',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/${queryParams ? queryParams : "brand-type-pref"}/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
    data,
  })
    .then(response => {
      // dispatch(fetchskinConcerns(queryParams, page))
    })
    .catch(error => {
      console.log(error)
    });
};

export const DeleteBrandPref = (id, queryParams, page) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  // let data = new FormData()
  // data.append("name", id)
  Axios({
    method: 'DELETE',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/${queryParams ? queryParams : "brand-type-pref"}/${id}/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      // dispatch(fetchskinConcerns(queryParams, page))
    })
    .catch(error => {
      console.log(error)
    });
};

export const UpdateSkinConcern = (id, name, concern_name, queryParams, page) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  let data = new FormData()
  data.append("user_profile", name)
  data.append("concern_name", concern_name)

  Axios({
    method: 'PUT',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/${queryParams ? queryParams : "skin-concern"}/${id}/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
    data,
  })
    .then(response => {
      console.log(response.data)
      dispatch(fetchskinConcerns(queryParams, page))
    })
    .catch(error => {
      console.log(error)
    });
};



// BLOG_TAGS_SECTION::::

export const getBlogTags = () => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  Axios({
    method: 'get',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/v2/admin-blog-tag/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      let blogTags = response.data.results.sort((a, b) => b.id - a.id)
      let totalCount = response.data.count
      dispatch(actions.blogTags({ blogTags, totalCount }));
      return blogTags
    })
    .catch(error => {
      console.log(error)
    });
};

export const addBlogTag = (name, setModel) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  let data = new FormData()
  data.append("name", name)
  Axios({
    method: 'post',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/v2/admin-blog-tag/`,
    data,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      dispatch(getBlogTags())
      setModel()
      return response
    })
    .catch(error => {
      console.log(error)
    });
};

export const updateBlogTag = (name, setModel, obj) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  let data = new FormData()
  data.append("name", name)
  Axios({
    method: 'put',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/v2/admin-blog-tag/${obj.id}/`,
    data,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      dispatch(getBlogTags())
      setModel()
      return response
    })
    .catch(error => {
      console.log(error)
    });
};

export const deleteBlogTag = (setModel, obj) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  Axios({
    method: 'delete',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/v2/admin-blog-tag/${obj.id}/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      dispatch(getBlogTags())
      setModel()
      return response
    })
    .catch(error => {
      console.log(error)
    });
};



// BLOG_SECTIONS::::

export const clearBlog = () => dispatch => {
  dispatch(actions.currentBlog({ currentBlog: false }));
}

export const getBlogs = (page) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  Axios({
    method: 'get',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/v2/admin-blog-post/?page=${page}&page_size=${10}&ordering=-updated_at`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      let blogs = response.data.results
      let totalCount = response.data.count
      dispatch(actions.blogs({ blogs, totalCount }));
      dispatch(actions.currentBlog({ currentBlog: false }));
      return blogs
    })
    .catch(error => {
      console.log(error)
    });
};

export const addBlog = (data, open) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  Axios({
    method: 'post',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/v2/admin-blog-post/`,
    data,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      dispatch(actions.currentBlog({ currentBlog: response.data }));
      open(response.data)
    })
    .catch(error => {
      console.log(error)
    });
};

export const updateBlog = (data, id) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  Axios({
    method: 'put',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/v2/admin-blog-post/${id}/`,
    data,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      dispatch(actions.currentBlog({ currentBlog: response.data }));
    })
    .catch(error => {
      console.log(error)
    });
};

export const deleteBlog = (id) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  Axios({
    method: 'delete',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/v2/admin-blog-post/${id}/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      dispatch(getBlogs(1));
    })
    .catch(error => {
      console.log(error)
    });
};

export const addProductToBlog = (data, id, setAddBlogProductModel, clear) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  Axios({
    method: 'post',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/v2/admin-blog-product/`,
    data,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      dispatch(actions.addedBlogProduct({ addedBlogProduct: response.data }));
      dispatch(getBlogs(1));
      dispatch(getProductSingle(id))
      setAddBlogProductModel(false)
      clear()
    })
    .catch(error => {
      console.log(error)
    });
};

export const updateBlogProduct = (data, setAddBlogProductModel, id) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  Axios({
    method: 'put',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/v2/admin-blog-product/${id}/`,
    data,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      dispatch(getProductSingle(response.data.blog_post))
      setAddBlogProductModel(false, false, false)
      window.location.reload()
    })
    .catch(error => {
      console.log(error)
    });
};

export const deleteProductFromBlog = (id, id2) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  Axios({
    method: 'delete',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/v2/admin-blog-product/${id2}/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      dispatch(getProductSingle(id))
      window.location.reload()
    })
    .catch(error => {
      console.log(error)
    });
};

export const getProductSingle = (id, setter) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  Axios({
    method: 'get',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/v2/admin-blog-post/${id}/`,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      dispatch(actions.currentBlog({ currentBlog: response.data }));
      // setter()
    })
    .catch(error => {
      console.log(error)
    });
};

export const clearCurrentBlog = () => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  dispatch(actions.clearCurrentBlog({ currentBlog: false }));
};


export const searchProducts = (val) => dispatch => {
  let code = getCookie("authToken")
  let data2 = {
    query: val,
    page: 1,
    products_per_page: 10
  }

  let data = new FormData()
  data.append("query", val)
  data.append("page", 1)
  data.append("products_per_page", 10)

  Axios({
    method: 'post',
    url: process.env.REACT_APP_BACKEND_URL + `/api/products/search/`,
    data,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      dispatch(actions.searchedProducts({ searchedProducts: response.data.products }));
    })
    .catch(error => {
      console.log(error)
    });
};



// After Update


export const addBlog2 = (data, arr, clearState) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  Axios({
    method: 'post',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/v2/admin-blog-post/`,
    data,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      dispatch(actions.currentBlog({ currentBlog: response.data }));
      for (let i = 0; i < arr.length; i++) {
        let obj = { ...arr[i], blog_post: response.data.id }
        dispatch(addProductToBlog2(obj));
        dispatch(getBlogs(1));
      }
      clearState()
    })
    .catch(error => {
      console.log(error)
    });
};


export const addProductToBlog2 = (data, singleAdded) => dispatch => {
  console.log(data)
  dispatch(actions.startCall({ callType: callTypes.list }));
  let code = getCookie("authToken")
  let dataa = new FormData()
  for (const property in data) {
    dataa.append(`${property}`, data[property])
  }
  Axios({
    method: 'post',
    url: process.env.REACT_APP_BACKEND_URL + `/api/admin/v2/admin-blog-product/`,
    data: dataa,
    validateStatus: (status) => {
      return true;
    },
    headers: { Authorization: `Bearer ${code}` },
  })
    .then(response => {
      dispatch(actions.addedBlogProduct({ addedBlogProduct: response.data }));
      // dispatch(getBlogs(1));
      if (singleAdded) {
        dispatch(getProductSingle(response.data.blog_post))
        window.location.reload()
      }
    })
    .catch(error => {
      console.log(error)
    });
};